import { Component, Input, OnChanges } from '@angular/core';
import { EntityFormField, PlanningFormData } from '../../services/entity-type.service';
import { FieldTemplate, TemplateFieldItem, TemplateNode } from './field-template';

@Component({
    selector: 'app-fields-template',
    standalone: false,
    templateUrl: './fields-template.component.html',
    styleUrl: './fields-template.component.scss',
})
export class FieldsTemplateComponent implements OnChanges {
    @Input() template: FieldTemplate;
    @Input() formData?: PlanningFormData;
    // Generieke, entityType-loze invoer: fieldGroup 'generic' resolvet fieldKey rechtstreeks in deze map.
    @Input() fields?: Map<string, EntityFormField>;

    fieldMap = new Map<TemplateFieldItem, EntityFormField>();

    ngOnChanges(): void {
        this.buildFieldMap();
    }

    private buildFieldMap(): void {
        this.fieldMap = new Map<TemplateFieldItem, EntityFormField>();

        if (!this.template || (!this.formData && !this.fields)) {
            return;
        }

        this.collectFieldItems(this.template.rows);
    }

    private collectFieldItems(nodes: TemplateNode[]): void {
        for (const node of nodes) {
            if (node.type === 'row' || node.type === 'div') {
                this.collectFieldItems(node.children);
            } else {
                const field = this.resolveField(node);
                if (field) {
                    this.fieldMap.set(node, field);
                }
            }
        }
    }

    private resolveField(item: TemplateFieldItem): EntityFormField | undefined {
        switch (item.fieldGroup) {
            case 'planning':
                return this.formData.planningFieldsMap?.get('planning')?.get(item.fieldKey);
            case 'planningData':
                return this.formData.planningFieldsMap?.get('planningData')?.get(item.fieldKey);
            case 'phe':
                return this.formData.mainPhe?.phe?.get(item.fieldKey);
            case 'pheData':
                return this.formData.mainPhe?.pheData?.get(item.fieldKey);
            case 'generic':
                return this.fields?.get(item.fieldKey);
        }
    }
}
